module.exports = __webpack_public_path__ + "img/green-location.f22ce75f.svg";